<template>
  <pt-detection-corpus-update class="pt-detection-corpus-update__page"></pt-detection-corpus-update>
</template>

<script>
import PtDetectionCorpusUpdate from 'cps/gene-product/pt-detection-corpus-update/withData'
export default {
  name: 'pt-detection-corpus-update__view',
  components: {
    'pt-detection-corpus-update': PtDetectionCorpusUpdate
  }
}
</script>
